import {
  any, boolean, date, nullable,
  number, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicReviewMask = {
  actId: string | nullable,
  collaborators: any,
  createdAt: date,
  description: string,
  owner: string | nullable,
  privateUpdatedAt: date | nullable,
  score: number,
  showId: string,
  updatedAt: date,
  venueId: string | nullable,

  processedDigest: boolean | nullable,
  isFeatured: boolean,
  isV2Review: boolean,
  selectedProfileId: string | nullable,
  selectedProfileType: string | nullable,
  targetProfileId: string,
  targetProfileType: string,
};
